var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81182 16.6683L0.336813 9.25831C-0.112271 8.81313 -0.112271 8.09132 0.336813 7.6461L1.96312 6.03389C2.41221 5.58867 3.14039 5.58867 3.58947 6.03389L8.625 11.0256L19.4105 0.333885C19.8596 -0.111295 20.5878 -0.111295 21.0369 0.333885L22.6632 1.9461C23.1123 2.39127 23.1123 3.11308 22.6632 3.55831L9.43817 16.6684C8.98904 17.1135 8.26091 17.1135 7.81182 16.6683Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7c51c7a7620ff5ea3a79b2aa9f33bdc9.svg";
export { ForwardRef as ReactComponent };